import { fetchCiamUserProfile, getCiamSessionToken } from './useCiamAuthorize'
import { useStore } from './useStore'

export const useCiamUpdateProfile = (profileData = {}) => {
  const { state, dispatch } = useStore()

  const handleUpdateProfile = async (payload = profileData) => {
    if (typeof window === 'undefined') {
      return false
    }

    const sessionToken = getCiamSessionToken() ?? ''
    const userId = state?.ciamUserId ?? ''

    try {
      const response = await fetch(
        `${process.env.GATSBY_API_URL}/ciam/user/${userId}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sessionToken}`,
          },
          body: JSON.stringify(payload),
        }
      )

      if (!response.ok) {
        return false
      }

      if (userId !== '') {
        const fresh = await fetchCiamUserProfile(userId, sessionToken)
        if (fresh != null) {
          dispatch({
            type: 'addToState',
            payload: { userData: fresh },
          })
        }
      }

      return true
    } catch (err) {
      console.error('Error calling CIAM PATCH /ciam/user:', err)
      return false
    }
  }

  return { handleUpdateProfile }
}
